import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import DownloadRegular from './download-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <DownloadRegular {...validProps} />;
}
SvgComponent.iconName = 'downloadRegular';

export const DownloadRegularIcon = svgIconWrapper(SvgComponent);
